export default __webpack_public_path__ + "static/media/yellow-cap.c037759f.svg";